function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "heart-outline_inline_svg__Icon_metro-heart",
  "data-name": "Icon metro-heart",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.836 3.856c-2.176 0-4.048 1.77-4.915 3.618C12.053 5.626 10.18 3.856 8 3.856A5.436 5.436 0 002.571 9.29c0 6.1 6.155 7.7 10.35 13.734C16.886 17.029 23.27 15.2 23.27 9.29a5.436 5.436 0 00-5.434-5.434z",
  transform: "translate(-2.571 -3.856)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.004 4.856A4.439 4.439 0 003.571 9.29c0 1.503.422 2.785 1.327 4.035.867 1.196 2.122 2.296 3.45 3.46 1.46 1.278 3.081 2.699 4.555 4.545 1.46-1.897 3.123-3.37 4.618-4.696 2.653-2.352 4.749-4.21 4.749-7.344a4.439 4.439 0 00-4.434-4.434c-1.774 0-3.322 1.577-4.01 3.043l-.905 1.929-.906-1.929c-.688-1.465-2.237-3.043-4.01-3.043m0-1c2.175 0 4.048 1.77 4.916 3.618.867-1.848 2.74-3.618 4.915-3.618 3 0 5.434 2.435 5.434 5.434 0 5.907-6.384 7.739-10.35 13.734C8.727 16.99 2.57 15.392 2.57 9.29c0-3 2.435-5.434 5.434-5.434z",
  fill: "#fdf7ec",
  transform: "translate(-2.571 -3.856)"
}));

function SvgHeartOutlineinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "heart-outline_inline_svg__Component_2_60",
    "data-name": "Component 2 \\u2013 60",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.699,
    height: 19.168,
    viewBox: "0 0 20.699 19.168"
  }, props), _ref);
}

export default SvgHeartOutlineinline;